import {IUser} from '../../../../models/user';
import {IProgram} from '../../../../models/program';
import {ICreateCleanUpForm} from '../index';
import s from '../index.module.scss';

interface Props {
    form: ICreateCleanUpForm;
    programs: IProgram[];
    collectors: IUser[];
    noCleaningConflict: string | null;
    onChange: (updates: Partial<ICreateCleanUpForm>) => void;
}

export default function Step1Program({
    form,
    programs,
    collectors,
    noCleaningConflict,
    onChange,
}: Props) {
    return (
        <div className={s.stepBody}>
            <div className={s.formGroup}>
                <label className={s.required}>Program</label>
                <select
                    value={form.programId}
                    onChange={(e) => onChange({programId: e.target.value})}
                    className={s.select}
                >
                    <option value="">Select a program</option>
                    {programs.map((p) => (
                        <option key={p.id} value={p.id}>
                            {p.name}
                        </option>
                    ))}
                </select>
                {!form.programId && (
                    <p className={s.fieldHint}>
                        All other steps load data based on the selected program.
                    </p>
                )}
            </div>

            <div className={s.formGroup}>
                <label className={s.required}>Date</label>
                <input
                    type="date"
                    value={form.date}
                    onChange={(e) => onChange({date: e.target.value})}
                    className={s.input}
                />
            </div>

            <div className={s.formGroup}>
                <label className={s.required}>Collector</label>
                <select
                    value={form.collectorId}
                    onChange={(e) => onChange({collectorId: e.target.value})}
                    className={s.select}
                    disabled={!form.programId}
                >
                    <option value="">
                        {form.programId
                            ? collectors.length > 0
                                ? 'Select a collector'
                                : 'No collectors in this program'
                            : 'Select a program first'}
                    </option>
                    {collectors.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.first_name} {c.last_name}
                        </option>
                    ))}
                </select>
                {form.programId && collectors.length === 0 && (
                    <p className={s.fieldHint}>
                        No active collectors are assigned to this program.
                    </p>
                )}
            </div>

            {noCleaningConflict && (
                <div className={s.conflictBanner}>
                    <span className={s.conflictIcon}>⚠</span>
                    <div>
                        <strong>No Cleaning Activities recorded for this day</strong>
                        <p>Reason: {noCleaningConflict}</p>
                        <p>
                            A clean-up cannot be created for this program on this date. To
                            proceed, the No Cleaning record must first be removed.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}
